export const plotStage = (plot, now) => {
  if (!plot) return "empty";
  if (now >= plot.wither_at) return "withered";
  if (now >= plot.ready_at) return "ready";
  const frac = (now - plot.planted_at) / plot.grow_sec;
  if (frac < 0.15) return "seed";
  if (frac < 0.5) return "sprout";
  return "growing";
};

export const fmtDuration = (sec) => {
  const s = Math.max(0, Math.ceil(sec));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m ${s % 60}s`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
  return `${Math.floor(s / 86400)}d ${Math.floor((s % 86400) / 3600)}h`;
};

export const STAGE_LABEL = { seed: "Seeded", sprout: "Sprout", growing: "Growing", ready: "Ready to harvest", withered: "Withered" };
